/* Atualiza o parcelamento quando a variante muda (página de produto).
   Guard global: o bloco de parcelamento é renderizado uma vez por card,
   então este arquivo pode ser referenciado várias vezes — executa só uma. */
(function () {
  if (window.__cardInstallmentsInit) return;
  window.__cardInstallmentsInit = true;

  document.addEventListener('DOMContentLoaded', function () {
    const installmentsContainer = document.querySelector('.card-installments');
    const productForm = document.querySelector('form[action*="/cart/add"]');

    if (!installmentsContainer || !productForm) return;

    productForm.addEventListener('change', function () {
      const variantInput = productForm.querySelector('[name="id"]');
      if (!variantInput) return;

      const variantId = variantInput.value;
      const section = installmentsContainer.closest('.shopify-section');
      const sectionId = section ? section.id.replace('shopify-section-', '') : null;

      if (variantId && sectionId) {
        installmentsContainer.style.opacity = '0.5';
        installmentsContainer.style.transition = 'opacity 0.2s ease';

        const fetchUrl = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;

        fetch(fetchUrl)
          .then(response => response.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newInstallments = doc.querySelector('.card-installments');

            if (newInstallments) {
              installmentsContainer.innerHTML = newInstallments.innerHTML;
              installmentsContainer.style.opacity = '1';
            }
          })
          .catch(error => {
            console.error('Erro ao atualizar o parcelamento:', error);
            installmentsContainer.style.opacity = '1';
          });
      }
    });
  });
})();
